import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailThreadedRepliesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmailThreadedReplies",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.64 19.87v-8.19c0-2.63 1.47-3.41 3.33-3.41h19.72c0-1.33-.71-1.96-2.88-1.96H5.09C3.39 6.31 2.01 7.7 2 9.4v10.7c-.03.93.69 1.7 1.61 1.74h.02v-1.96Zm4.53 5.82H26.9c1.71 0 3.1-1.39 3.1-3.1v-9.81c0-1.71-1.39-3.1-3.1-3.1H8.17c-1.71 0-3.1 1.39-3.1 3.1v9.81c0 1.71 1.39 3.1 3.1 3.1m.78-10.92a.85.85 0 0 1-.21-.56c0-.49.39-.9.88-.9.17 0 .34.04.48.14l6.24 5.56c.68.6 1.7.6 2.37 0l6.24-5.56a.89.89 0 0 1 1.48.67c0 .25-.11.5-.29.67l-3.1 2.76 3.16 3.03c.36.33.39.9.06 1.26-.17.19-.41.29-.66.29a.88.88 0 0 1-.64-.28l-3.25-3.15-1.83 1.6c-.65.58-1.49.89-2.36.89-.88 0-1.72-.31-2.38-.89l-1.78-1.6-3.24 3.17a.892.892 0 0 1-1.54-.61c-.01-.26.09-.51.28-.69l3.15-3.06-3.06-2.75Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27 26H9c-1.65 0-3-1.35-3-3V12c0-1.65 1.35-3 3-3h18c1.65 0 3 1.35 3 3v11c0 1.65-1.35 3-3 3M9 11c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V12c0-.55-.45-1-1-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 20c-.55 0-1-.45-1-1V8c0-1.65 1.35-3 3-3h18c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1 .45-1 1v11c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18 19.67a1 1 0 0 1-.55-.17l-7-4.67a1.01 1.01 0 0 1-.28-1.39c.31-.46.93-.58 1.39-.28l6.45 4.3 6.45-4.3a1.001 1.001 0 1 1 1.11 1.67l-7 4.67c-.17.11-.36.17-.55.17Z"
      })]
    })
  }));
};